"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _resetNotLiveVideoSource = require("@studio/sources/resetNotLiveVideoSource");
var _attachAudioPresenterSources = require("@studio/sources/attachAudioPresenterSources");
var _sceneBuilder = require("@studio/program/sceneBuilder/sceneBuilder");
var _Sources = require("@studio/constants/Sources");
var _setSceneLayout = _interopRequireDefault(require("./setSceneLayout"));
var _queueStageLayout = _interopRequireDefault(require("./queueStageLayout"));
var _sources = require("../../utils/sources");
var _sendToDatadogWithIds = require("../../utils/sendToDatadogWithIds");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
/**
 * Since `setProgram` will be different in .lite and .pro,
 * this action will accept `setProgram`
 * as a parameter and dispatch it.
 * @param {{}} layout
 * @param {boolean} retainLiveCameraSources
 * @param {Function} setProgram  Action be passed from director
 * @param {Function} updateSource  Action be passed from director
 */
function selectLayout(layout, retainLiveCameraSources, setProgram, updateSource, endHostChangesStageLayout) {
  return function (dispatch, getState) {
    var _getState = getState(),
      banners = _getState.banners,
      program = _getState.program,
      sceneLayers = _getState.sceneLayers,
      liveSources = _getState.liveSources,
      serverTimeDelta = _getState.serverTimeDelta,
      featuredPresenter = _getState.featuredPresenter,
      attendeeMuteStatus = _getState.attendeeMuteStatus,
      dragAndDrop = _getState.broadcastSettings.dragAndDrop,
      stagedSources = _getState.stagedSources.sources,
      broadcastSources = _getState.broadcastSources.sources,
      brandingSettings = _getState.brandingSettings;
    var isStaged = Object.keys(stagedSources).reduce(function (acc, sId) {
      return acc || stagedSources[sId];
    }, false);
    if (isStaged) {
      return dispatch((0, _queueStageLayout["default"])(layout));
    }
    var programSources = program.layers.map(function (layerSource) {
      return layerSource.source;
    });
    var sourcesWithOnlyLiveCameras = programSources.filter(function (source) {
      if (source.type === _Sources.CAMERA_PRESENTER && !liveSources.includes(source._id)) return false;
      return true;
    });
    var newSources = retainLiveCameraSources ? sourcesWithOnlyLiveCameras : programSources;
    var sources = addFeaturedPresenter(newSources, featuredPresenter);
    var combinedLayers = [].concat(_toConsumableArray(sceneLayers), _toConsumableArray(banners));
    var sceneSources = dragAndDrop ? (0, _sources.orderSources)(sources) : sources;
    var resetSources = (0, _resetNotLiveVideoSource.resetNotLiveVideoSource)(liveSources, sceneSources, serverTimeDelta, dispatch, updateSource);
    var withAudioPresenterSources = (0, _attachAudioPresenterSources.attachAudioPresenterSources)(resetSources, attendeeMuteStatus);
    var scene = (0, _sceneBuilder.sceneBuilder)(layout, withAudioPresenterSources, combinedLayers, {}, {}, brandingSettings === null || brandingSettings === void 0 ? void 0 : brandingSettings.fonts);
    scene.style = program.style;

    /**
     * Check if there is any live audio source
     * before transferring it to the newly built scene.
     */
    var liveAudioSource = broadcastSources.filter(function (source) {
      return source.type === _Sources.AUDIO_FILE;
    }).map(function (audioSource) {
      return audioSource._id;
    }).some(function (audioSourceId) {
      return liveSources.includes(audioSourceId);
    });
    var newScene = liveAudioSource ? (0, _sources.transferAudioSourceLayer)(program, scene) : scene;
    if (setProgram && typeof setProgram === 'function') {
      dispatch(setProgram(newScene, false, {
        emitSocket: true
      }, endHostChangesStageLayout));
      (0, _sendToDatadogWithIds.logProgramChange)(getState, 'selectLayout action');
    }
    dispatch((0, _setSceneLayout["default"])(layout));
  };
}

/**
 * @param {Array} sources
 * @param {string} featuredPresenterId
 */
function addFeaturedPresenter(sources, featuredPresenterId) {
  return sources === null || sources === void 0 ? void 0 : sources.map(function (source) {
    return _objectSpread(_objectSpread({}, source), {}, {
      featured: source.type === _Sources.CAMERA_PRESENTER && source._id === featuredPresenterId
    });
  });
}
var _default = exports["default"] = selectLayout;